import Vue from 'vue'

/**
 * Element clickoutside is not prepared to listen to events inside a child,
 * so I added a new directive
 */
Vue.directive('click-outside', {
  bind: (el: any, binding: any, vnode: any) => {
    el.clickOutsideEvent = (event: any) => {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: el => {
    // @ts-ignore
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
})
